import { makeRequest } from '@/base/MaRequestPooler.js'

/**
 * Returns API Keys.
 * @returns {Promise<any>}
 */
export function getAccountApiKeys() {
  return makeRequest(`/account/api-keys`)
}

/**
 * Returns status of a token.
 * @param token
 * @returns {Promise<any>}
 */
export function getApiKeyStatus(token) {
  return makeRequest(`/account/api-key/${token}/status`)
}

/**
 * Recreate a token.
 * @param token
 * @returns {Promise<any>}
 */
export function recreateToken(token) {
  return makeRequest(`/account/api-key/${token}/recreate`, {
    method: 'POST',
  })
}

/***
 * Returns daily credit usage of given api key token between startDate and endDate
 * @param token Api key token
 * @param startDate Inclusive start date
 * @param endDate Inclusive end date (max allowed date range is currently 6 months)
 * @return Daily credit usage list, padded with zero for days with no data
 */
export function getDailyUsage(token, startDate, endDate) {
  return makeRequest(`/account/api-key/${token}/daily-credit-usage/${startDate}/${endDate}`)
}
